/** Subscription expiry and renewal (POS.md §13.3, §18.6). */

export const RENEWAL_ENDPOINTS = {
  /** Staff (`renewals:list`): this business's requests, newest first, plus `expiration_date`. */
  list: '/api/backoffice/renewal',
  /** Staff (`renewals:submit`): a pre-signed PUT for the proof file. */
  proofUploadUrl: '/api/backoffice/renewal/proof-upload-url',
  /** Staff (`renewals:submit`): send the request (one pending at a time). */
  submit: '/api/backoffice/renewal',
} as const

export type RenewalStatus = 'pending' | 'approved' | 'rejected'

export interface Renewal {
  _id: string
  proof_name: string
  proof_type: string
  note?: string
  submitted_by?: { staff_id: string; name: string }
  status: RenewalStatus
  reject_reason?: string
  new_expiration_date?: string | null
  reviewed_at?: string | null
  created_at: string
}

export interface RenewalSubmit {
  proof_path: string
  proof_name: string
  proof_type: string
  note?: string
}

/** Proof files the server accepts. */
export const RENEWAL_PROOF_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/webp'] as const

/** When the alert bar starts warning, in days before expiry (the first reminder email goes at 90). */
export const RENEWAL_WARN_DAYS = 30

/** Whole days from today to `expiration`, in the viewer's local day; negative once expired. Null without a date. */
export const daysUntilExpiry = (expiration: string | Date | null | undefined, now = new Date()) => {
  if (!expiration) return null
  const end = new Date(expiration)
  const a = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())
  const b = Date.UTC(end.getFullYear(), end.getMonth(), end.getDate())
  return Math.round((b - a) / 86400000)
}

/** `code` on the server's 403 when the business is suspended in System Admin: the POS keeps its data, cannot sync. */
export const BUSINESS_INACTIVE_ERROR = 'BUSINESS_INACTIVE'
